"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TagsGroup = _interopRequireDefault(require("../../../TagsGroup/TagsGroup"));
var _TextWithSyllabification = _interopRequireDefault(require("../../TextWithSyllabification/TextWithSyllabification"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.event-occurrence-top {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin: auto; }\n  .event-occurrence-top .tags {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 8px; }\n    .event-occurrence-top .tags .status {\n      font-size: 16px; }\n  .event-occurrence-top .bottom {\n    display: flex;\n    flex-direction: column; }\n";
  const fileName = "EventOccurrenceTop_EventOccurrenceTop";
  const element = document.querySelector("style[data-sass-component='EventOccurrenceTop_EventOccurrenceTop']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIAEventOccurrenceText = _ref => {
  let {
    value,
    valueMultiple,
    label,
    lang
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-04 sia-margin-03-bottom"
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    lang: lang
  }, label)), value && /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    className: "sia-text-10 sia-margin-03-bottom",
    lang: lang
  }, value), valueMultiple && valueMultiple.map(el => /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    key: el,
    className: "sia-text-10 sia-margin-03-bottom",
    lang: lang
  }, el)));
};
const EventOccurrenceTop = _ref2 => {
  let {
    formatName,
    eventOrganisatorName,
    eventLocations,
    eventLanguages,
    eventTitle,
    status,
    statusLabel,
    eventLead,
    eventSublead,
    eventSubleadMultiple,
    translate,
    core_topics,
    lang
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "event-occurrence-top "
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tags sia-margin-03-bottom"
  }, /*#__PURE__*/_react.default.createElement(_TagsGroup.default, {
    items: [...(eventOrganisatorName ? [{
      label: eventOrganisatorName.label,
      type: 'tertiary'
    }] : []), ...(eventLocations?.length > 0 ? eventLocations.map(location => ({
      label: location,
      type: 'tertiary'
    })) : []), ...(formatName ? [{
      label: formatName,
      type: 'tertiary'
    }] : []), ...(eventLanguages && eventLanguages?.length > 0 ? eventLanguages.map(language => ({
      label: language?.name?.slice(0, 2)?.toUpperCase(),
      type: 'quaternary'
    })) : []), ...(core_topics && core_topics?.length > 0 ? core_topics.map(topic => ({
      label: topic.label,
      type: 'quinary'
    })) : [])]
  }), status && status === 'event_occurrence_status_fully_booked' && /*#__PURE__*/_react.default.createElement("p", {
    className: "status sia-text-02",
    dangerouslySetInnerHTML: {
      __html: statusLabel
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom"
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    className: "title sia-text-12 sia-margin-03-bottom",
    lang: lang
  }, eventTitle), /*#__PURE__*/_react.default.createElement(SIAEventOccurrenceText, {
    value: eventSublead,
    valueMultiple: eventSubleadMultiple,
    label: eventLead,
    lang: lang
  })));
};
EventOccurrenceTop.propTypes = {
  formatName: _propTypes.default.string,
  status: _propTypes.default.string,
  eventOrganisatorName: _propTypes.default.string,
  eventLocations: _propTypes.default.arrayOf(_propTypes.default.string),
  eventLanguages: _propTypes.default.arrayOf(_propTypes.default.string),
  eventTitle: _propTypes.default.string,
  eventLead: _propTypes.default.string,
  eventSublead: _propTypes.default.string,
  translate: _propTypes.default.func,
  lang: _propTypes.default.string
};
var _default = exports.default = EventOccurrenceTop;